import { render } from "./LayoutAuthSidebar.vue?vue&type=template&id=f77a87a6&scoped=true&ts=true"
import script from "./LayoutAuthSidebar.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthSidebar.vue?vue&type=script&lang=ts"

import "./LayoutAuthSidebar.vue?vue&type=style&index=0&id=f77a87a6&scoped=true&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77a87a6"]])

export default __exports__